import {isMobile} from "react-device-detect";
import {useHistory} from "react-router-dom";
import {Col, Row} from "react-grid-system";
import {useSelector} from "react-redux";
import Button from "components/Button";
import serialize from "form-serialize";
import Select from "components/Select";
import Input from "components/Input";
import functions from "functions";
import React, {useEffect} from "react";
import axios from "axios";
import {useStateIfMounted} from "use-state-if-mounted";

function User() {
	let language = useSelector(state => state.Language.language);

	const [loading, setLoading] = useStateIfMounted(false);
	const [user, setUser] = useStateIfMounted([]);
	let id = useSelector(state => state.Session.id);
	const history = useHistory();
	useEffect(() => {
		async function getUser() {
			let response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get/user/${id}`)
			await setUser(response.data.result)
		}

		void getUser()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id]);

	async function add(event) {
		event.preventDefault()
		setLoading(true)
		let response = await axios.post(`${process.env.REACT_APP_API_URL}/api/add/user`, `${serialize(event.target)}&user_id=${id}`)
		response = response.data
		if (response.ok) {
			await functions.message("success", language["process_successful"], language[response.ok], false, "", true, "top-end", 1500)
			setTimeout(function () {
				history.push("/panel/users")
				setLoading(false)
			}, 1500);
		} else if (response.error) {
			await functions.message("error", language["process_failed"], language[response.error], true, language["process_failed_close_button"], false, "center", 0)
			setLoading(false)
		} else {
			await functions.message("error", language["process_failed"], "", true, language["process_failed_close_button"], false, "center", 0)
			setLoading(false)
		}
	}

	const pleaseSelect = [
		{
			label: language["please_select"],
			value: ""
		}
	]
	const types = [
		{
			label: language["user_type0"],
			value: "0"
		},
		{
			label: language["user_type1"],
			value: "1"
		},
		{
			label: language["user_type2"],
			value: "2"
		},
	]
	return (
		<div>
			<div className="panelTitle">{language["add_user_page_title"]}</div>
			<div className="wrapper">
				<form onSubmit={add}>
					<Row>

						{
							user.type === "2" ?
								<>
									<Input type={"email"} name={"email"} col={6} icon={"BiAt"} title={language["email_input_title"]} placeholder={language["email_input_placeholder"]} forced={true}/>
									<Input type={"password"} name={"password"} col={6} icon={"MdOutlinePassword"} title={language["password_input_title"]} placeholder={language["password_input_placeholder"]} forced={true}/>
									<Input type={"number"} name={"card_limit"} col={6} icon={"AiOutlineFieldNumber"} title={language["card_limit_input_title"]} placeholder={language["card_limit_input_placeholder"]} forced={true}/>
									<Select title={language["user_type_input_title"]} icon={"AiOutlineStar"} col={6} name={"type"} defaultValue={""} values={isMobile ? pleaseSelect.concat(types) : types} forced={true} placeholder={language["user_type_input_placeholder"]}/>
								</>
								:
								<>
									<Input type={"email"} name={"email"} col={4} icon={"BiAt"} title={language["email_input_title"]} placeholder={language["email_input_placeholder"]} forced={true}/>
									<Input type={"password"} name={"password"} col={4} icon={"MdOutlinePassword"} title={language["password_input_title"]} placeholder={language["password_input_placeholder"]} forced={true}/>
									<Input type={"number"} name={"card_limit"} col={4} icon={"AiOutlineFieldNumber"} title={language["card_limit_input_title"]} placeholder={language["card_limit_input_placeholder"]} forced={true}/>
								</>
						}

						<Col md={12} className="button_area">
							<Button icon="GoPlus" name={language["add_button"]} loading={loading}/>
						</Col>
					</Row>
				</form>
			</div>
		</div>
	)
}

export default User